import { render, staticRenderFns } from "./CurrentPeriodTable.vue?vue&type=template&id=0cc51233&"
import script from "./CurrentPeriodTable.vue?vue&type=script&lang=js&"
export * from "./CurrentPeriodTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports